$(document).ready(function(){
  // $('.instant-add-custom').on('click',function(e){
  //     e.preventDefault();
  //     $(this).parents('.card__content.card-display-custom').find('[name="add"]').trigger('click');
  // });

  $('.collection-sidebar-menu li:eq(0) a').addClass('active');
  
  $(document).on('click','.collection-sidebar-menu li a',function(){
    $('.collection-sidebar-menu li a').removeClass('active');
    $(this).addClass('active');
  })

  $(document).on('keyup','#made-for-cust',function(){
    var dInput = $(this).val();
    $('.customize-properties-for-cart #made-for').val(dInput);
  });

  $(document).on('keyup','#special-instructions-cust',function(){
    var dInput = $(this).val();
    $('.customize-properties-for-cart #special-instructions').val(dInput);
  });
  
  $(document).on('click','.go-back-svg',function(){
    history.back();
  })

  //  $('.quick-add__submit').on('click',function(e){
     
  //     $(".closepopp").click();
  // });
// ----------------equal height
//   var maxHeight = 0;

// $(".inner_new").each(function(){
//    if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
// });

// $(".inner_new").height(maxHeight);
})